import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbContextMenuModule,
  NbIconModule,
  NbLayoutModule,
  NbMenuModule,
  NbSearchModule,
  NbSelectModule,
  NbSidebarModule,
  NbThemeModule,
  NbUserModule,
} from '@nebular/theme';

import { MaterialModule } from '../../material.module';
// import { ShareModule } from 'ngx-sharebuttons';
import { SharedModule } from '../shared/shared.module';
import { FooterComponent, HeaderComponent } from './components';
import { SelectHeaderSchoolComponent } from './components/select-header-school/select-header-school.component';
import { AcceptNumberOnlyDirective } from './directives/accept-number-only.directive';
import { FiveDigitAlphanumericDirective } from './directives/five-digit-alphanumeric.directive';
import { TextareaAutoresizeDirective } from './directives/textarea-autoresize.directive';
import { TrimWhitespacesDirective } from './directives/trim-whitespaces.directive';
import { OneColumnLayoutComponent, ThreeColumnsLayoutComponent, TwoColumnsLayoutComponent } from './layouts';
import { CapitalizePipe, NumberWithCommasPipe, PluralPipe, RoundPipe, TimingPipe } from './pipes';
import { MATERIAL_DARK_THEME } from './styles/material/theme.material-dark';
import { MATERIAL_LIGHT_THEME } from './styles/material/theme.material-light';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { DARK_THEME } from './styles/theme.dark';
import { DEFAULT_THEME } from './styles/theme.default';

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  SelectHeaderSchoolComponent,
  TextareaAutoresizeDirective,
  FiveDigitAlphanumericDirective,
  AcceptNumberOnlyDirective,
  TrimWhitespacesDirective,
];
const PIPES = [CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe];

@NgModule({
  imports: [
    CommonModule,
    MatRippleModule,
    ...NB_MODULES,
    MaterialModule,
    // ShareModule,
    FormsModule,
    NbCardModule,
    SharedModule,
  ],
  exports: [CommonModule, MatRippleModule, ...PIPES, ...COMPONENTS],
  declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        ...NbThemeModule.forRoot(
          {
            name: 'material-light',
          },
          [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME, MATERIAL_LIGHT_THEME, MATERIAL_DARK_THEME],
        ).providers,
      ],
    };
  }
}
